import { render, staticRenderFns } from "./PagePart2.vue?vue&type=template&id=45a5da36&scoped=true"
import script from "./PagePart2.vue?vue&type=script&lang=js"
export * from "./PagePart2.vue?vue&type=script&lang=js"
import style0 from "./PagePart2.vue?vue&type=style&index=0&id=45a5da36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a5da36",
  null
  
)

export default component.exports